import {createFileRoute, useNavigate} from "@tanstack/react-router";
import {WasteDiaryView, WasteTimelineRelay} from "../../../waste/timeline.tsx";
import {Box, Stack} from "@mui/joy";
import {IconToggleSwitch, ToggleBar} from "../../../components/ToggleBar.tsx";
import {Facet, facetIcons} from "../../../components/Facet.tsx";
import {SortOrder, useWasteById, useWasteFlavorById, WasteFlavorStub} from "../../../rpc/webrpc-client.gen.ts";
import {useCallback, useEffect, useState} from "react";

import {defaultPrefs} from "../../../util/defaultPrefs.tsx";
import {useBomb} from "../../../bomb/bomb.tsx";
import {sortOrderIcons} from "../../../tq/tqutil.tsx";
import {PageBody, PageHeader, PageShell} from "../../../routing/shell.tsx";
import {TopBar} from "../../../components/TopBar.tsx";
import {useStampWasteMutation} from "../../../tq/tqx.tsx";
import {GenericFlavorlessStampSpawnFood} from "../../../stamp/genericFlavorlessStampSpawnFood.tsx";
import {TimelineStampInput} from "../../../stamp/timelineStampInput.tsx";
import {usePreferences} from "../../../agent/usePreferences.ts";

function WasteTimelinePage() {
    const navigate = useNavigate();
    const {id: wasteId} = Route.useParams();
    const bomb = useBomb();
    //const mama = useMothership();
    const wasteTqrv = useWasteById({wasteId});
    const waste = wasteTqrv.data;
    const flavorTqrv
        = useWasteFlavorById(waste && {wasteFlavorId: waste.flavor.id});
    const xflavor = flavorTqrv.data;
    const [marqueeFlavor, setMarqueeFlavor] = useState<WasteFlavorStub | undefined>(xflavor);
    useEffect(() => {
        setMarqueeFlavor(xflavor);
    }, [xflavor]);
    const {data: prefs} = usePreferences();
    const [sortOrder, setSortOrder] = useState<SortOrder>(prefs?.wasteSortOrder ?? defaultPrefs.wasteSortOrder);

    const {mutateAsync: performStamp} = useStampWasteMutation();
    const stampGeneric = useCallback((gf: GenericFlavorlessStampSpawnFood) =>
        performStamp({food: {wasteId, ...gf}}), [performStamp, wasteId]);

    return <PageShell>
        <WasteTimelineRelay wasteId={wasteId}/>

        <PageHeader>
            <Stack direction="column">
                <TopBar/>

                <ToggleBar>
                    <Box sx={{flex: 0}}>
                        <IconToggleSwitch dispatchValue={(next: Facet) => {
                            if (next === "cargo") {
                                navigate({to: "/waste/$id/cargo", params: {id: wasteId}})
                                    .catch(bomb);
                            }
                        }} icons={facetIcons} value="cargo"/>
                    </Box>
                    <Stack direction="row" sx={{justifyContent: "center", alignItems: "center", flex: 1}}>
                        {marqueeFlavor
                            ? <Box sx={{fontSize: "lg"}}>{marqueeFlavor.displayName}</Box>
                            : null}
                    </Stack>
                    <IconToggleSwitch icons={sortOrderIcons} value={sortOrder} dispatchValue={setSortOrder}/>
                </ToggleBar>

                <TimelineStampInput addStamp={stampGeneric}/>
            </Stack>
        </PageHeader>
        <PageBody>
            <WasteDiaryView wasteId={wasteId} sortOrder={sortOrder}/>
        </PageBody>
    </PageShell>;
}

export const Route = createFileRoute("/_auth/waste/$id/timeline")({
    component: WasteTimelinePage
});
